/**
 * @author      carlos.soto@zumper.com (Carlos J. Soto)
 * @copyright   Copyright (c) 2022, Zumper
 * @description Desktop Header
 */

import type { AutocompleteResult } from '@zcode/bizos'
import type { Filters } from '@zcode/state-type'
import React from 'react'
import type { PassedHeaderProps } from '../../types'
import {
  DesktopSingleNavInput,
  type DesktopSingleNavInputProps,
} from './DesktopSingleNavInput/DesktopSingleNavInput'
import { NavWrapper, type NavWrapperProps } from './NavWrapper/NavWrapper'

export type HeaderDesktopProps = Pick<
  PassedHeaderProps,
  | 'detailCityAndState'
  | 'detailLocationObj'
  | 'dispatchMixpanelAutocompleteResultClick'
  | 'dispatchMixpanelCompleteSearch'
  | 'dispatchMixpanelNavClick'
  | 'getCurrentLocationName'
  | 'isCurrentSearchView'
  | 'isDetailView'
  | 'locationName'
  | 'mapListNavTestId'
  | 'mixpanelEvent'
  | 'onSelectAutocompleteResult'
> &
  Omit<NavWrapperProps, 'isCurrentSearchView' | 'isDetailView'> &
  Partial<Pick<NavWrapperProps, 'isCurrentSearchView' | 'isDetailView'>>

export const HeaderDesktop = (props: HeaderDesktopProps) => {
  const {
    detailCityAndState,
    detailLocationObj,
    dispatchMixpanelAutocompleteResultClick,
    dispatchMixpanelCompleteSearch,
    dispatchMixpanelNavClick,
    getCurrentLocationName,
    isCurrentSearchView,
    isDetailView,
    locationName,
    mapListNavTestId,
    mixpanelEvent,
    onSelectAutocompleteResult: onSelectAutocompleteResultProp,
  } = props
  const [isMapListNav, setIsMapListNav] = React.useState(isCurrentSearchView)

  React.useEffect(() => {
    if (isCurrentSearchView) {
      setIsMapListNav(true)
    }
  }, [isCurrentSearchView])

  const onSelectAutocompleteResult = (result: AutocompleteResult, filters?: Filters) => {
    onSelectAutocompleteResultProp(result, filters)
  }

  const mapListProps = {
    detailCityAndState,
    detailLocationObj,
    dispatchMixpanelAutocompleteResultClick,
    dispatchMixpanelCompleteSearch,
    dispatchMixpanelNavClick,
    getCurrentLocationName,
    isCurrentSearchView,
    isDetailView,
    locationName,
    mapListNavTestId,
    mixpanelEvent,
    onSelectAutocompleteResult,
  } satisfies DesktopSingleNavInputProps

  const wrapperProps = {
    isCurrentSearchView: isMapListNav,
    isDetailView,
    ...props,
  } satisfies NavWrapperProps

  return (
    <NavWrapper {...wrapperProps}>
      <DesktopSingleNavInput {...mapListProps} />
    </NavWrapper>
  )
}
